import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const AccessRoutes = 'AccessRoutes'
const packageList = 'packageList'
const enumcodes = 'enumcodes'
function setCookie(name, value, options = {}) {
    let expires = options.expires;

    if (typeof expires == "number" && expires) {
        const d = new Date();
        d.setTime(d.getTime() + expires * 1000);
        expires = options.expires = d.toGMTString();
    }

    if (expires && expires.toUTCString) {
        options.expires = expires.toUTCString();
    }

    value = encodeURIComponent(value);

    let updatedCookie = `${name}=${value}`;

    for (let optionKey in options) {
        updatedCookie += `; ${optionKey}`;
        const optionValue = options[optionKey];
        if (optionValue !== true) {
            updatedCookie += `=${optionValue}`;
        }
    }

    document.cookie = updatedCookie;
}

export function getToken() {
    return Cookies.get(TokenKey)
}

export function setToken(token) {
    setCookie(TokenKey, token, { path: '/' });
    setCookie(TokenKey, token, { domain: window.location.hostname, path: '/' });
}

export function removeToken() {
    setCookie(TokenKey, "", { path: '/', expires: -1 });
    setCookie(TokenKey, "", { domain: window.location.hostname, path: '/', expires: -1 });
}

export function setAccessRoutes(routeList) {
    return Cookies.set(AccessRoutes, JSON.stringify(routeList))
}

export function getAccessRoutes() {
    return Cookies.get(AccessRoutes)
}

export function removeAccessRoutes() {
    return Cookies.remove(AccessRoutes)
}

export function getPackageList() {
    //   return Cookies.get(packageList)
    if (!!localStorage) {
        return localStorage.getItem(packageList);
    }
}

export function setPackageList(list) {
    //   return Cookies.set(packageList, List)
    if (!!localStorage) {
        return localStorage.setItem(packageList, JSON.stringify(list));
        // localStorage.setItem("json", JSON.stringify(json));
    }
}

export function removePackageList() {
    //   return Cookies.remove(packageList)
    if (!!localStorage) {
        return localStorage.removeItem(packageList);
    }
}

export function getenumcodes() {
    //   return Cookies.get(enumcodes)
    if (!!localStorage) {
        return localStorage.getItem(enumcodes);
    }
}

export function setenumcodes(list) {
    //   return Cookies.set(enumcodes, List)
    if (!!localStorage) {
        return localStorage.setItem(enumcodes, JSON.stringify(list));
        // localStorage.setItem("json", JSON.stringify(json));
    }
}


// WEBPACK FOOTER //
// ./src/utils/auth.js